export const IMAGETYPE_FROM_DOCUMENTTYPE_UPDATED =
  'IMAGETYPE_FROM_DOCUMENTTYPE_UPDATED'
